import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useMarketingUIContext } from "../MarketingUIContext";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { fetchMarketingBanners } from '../../../actions/banners/banners';
import {saveAs} from "file-saver";

export function MarketingTable() {

  const [loader, setLoader] = useState(true);

  const { marketingBanners } = useSelector(
    (state) => ({
      marketingBanners:
        state.banners && state.banners.marketingBanner && state.banners.marketingBanner.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
        state.banners && state.banners.marketingBanner && state.banners.marketingBanner.totalDocs,
    }),
    shallowEqual
  );


  const dispatch = useDispatch();

  const marketingUIContext = useMarketingUIContext();
  const marketingUIProps = useMemo(() => {
    return {
      ids: marketingUIContext.ids,
      setIds: marketingUIContext.setIds,
      queryParams: marketingUIContext.queryParams,
      setQueryParams: marketingUIContext.setQueryParams,
      openEditBannerPage: marketingUIContext.openEditBannerPage,
      openDeleteBannerDialog: marketingUIContext.openDeleteBannerDialog,
    };
  }, [marketingUIContext]);

  useEffect(() => {

    async function getmarketingBanners () {
      setLoader(true);

      await dispatch(fetchMarketingBanners(marketingUIProps.queryParams));
      
      setLoader(false);
    }

    getmarketingBanners();
  }, [marketingUIProps.queryParams, dispatch]);

  const downloadImage = (file_path, file_name) => {
    let base_url = 'https://central.ccdemostore.com/uploads/banners/';

    saveAs(base_url+file_path, file_name)
  }

  
  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];
  
    // Table pagination properties
    const paginationOptions = {
      custom: true,
      totalSize: count === null ? 0 : count,
      sizePerPageList: sizePerPageList,
      sizePerPage: marketingUIProps.queryParams.pageSize,
      page: marketingUIProps.queryParams.pageNumber,
    };


  const columns = [
    {
      dataField: "index",
      text: "Id",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.RowIndex,
      style: { minWidth: "70px" },
      formatExtraData: {paginationOptions}
    },
    {
      dataField: "b_name",
      text: "Banner Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "banner_file",
      text: "Download Banner",
      sort: false,
      formatter: columnFormatters.DownloadColumnFormatter,
      style: { minWidth: "150px" },
      formatExtraData: {
        downloadFile: downloadImage,
      },
    },
    {
      dataField: "isin_shopify",
      text: "Displayed in Platform",
      sort: false,
      formatter: columnFormatters.PlatformColumnFormatter,
      style: { minWidth: "230px" },
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      formatter: columnFormatters.StatusColumnFormatter,
      style: { minWidth: "70px" },
    },
    {
      dataField: "date",
      text: " Created At",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.CreateDateColumnFormatter,
      style: {
        minWidth: "130px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditBannerPage: marketingUIProps.openEditBannerPage,
        openDeleteBannerDialog: marketingUIProps.openDeleteBannerDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];

  
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                data={marketingBanners === null ? [] : marketingBanners}
                onTableChange={getHandlerTableChange(
                  marketingUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => marketingBanners === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader &&  <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
